webpackJsonp([314],{

/***/ 1041:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  head: { "title": "VUX V2.2.1Rc.8 released | VUX - Vue.js Mobile UI Component Framework", "ignoreSuffixChar": "|" }
});

/***/ }),

/***/ 1856:
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(67)(
  /* script */
  __webpack_require__(1041),
  /* template */
  __webpack_require__(2003),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/home/runner/work/vux/vux/docs/node_modules/v-markdown-loader/_cache/v2.2.1-rc.8-97.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] v2.2.1-rc.8-97.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-02a422a4", Component.options)
  } else {
    hotAPI.reload("data-v-02a422a4", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),

/***/ 2003:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("VUX V2.2.1Rc.8 released")]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/datetime.html"
    }
  }, [_vm._v("Datetime")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[enhance] now changing prop:format will trigger re-rendering")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/popup-radio.html"
    }
  }, [_vm._v("PopupRadio")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] fix label width")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/scroller.html"
    }
  }, [_vm._v("Scroller")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[change] set prop:prevent-default to false by default")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/x-number.html"
    }
  }, [_vm._v("XNumber")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] fix cannot edit first number character when fillable")])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-02a422a4", module.exports)
  }
}

/***/ }),

/***/ 514:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1856);

/***/ })

});


// WEBPACK FOOTER //
// 314.124439c9.js